import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../../validators/cdn-asset-options';
export const defaultFilmTitleCdnOptions = {
    censorRatingIcon: { height: 60 }
};
export const filmTitleCdnOptionsValidator = Validator.object({
    censorRatingIcon: cdnStandardAssetOptionsValidator
});
//# sourceMappingURL=cdn-options.js.map